import {Component, OnInit, ViewChild} from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {RegistrationProcessInfoResource, RegistrationProcessInfoResponse} from '@services/ma/registration-process';
import {RegistrationProcessQuery, RegistrationProcessService} from '@services/ma/registration-process.service';
import {MatPaginator} from '@angular/material/paginator';
import {map, share, startWith, switchMap} from 'rxjs/operators';
import {Pagination} from '@util/pagination';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatSort, Sort} from '@angular/material/sort';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {MatFormField} from '@angular/material/form-field';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import {CommonModule} from '@angular/common';
import {MatInput} from '@angular/material/input';
import {MomentPipe} from '@util/pipes/moment-pipe';

@Component({
  selector: 'app-registration-debugger',
  templateUrl: './registration-debugger.component.html',
  styleUrls: ['./registration-debugger.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCard,
    MatCardTitle,
    MatCardContent,
    ReactiveFormsModule,
    MatFormField,
    MatTable,
    MatPaginator,
    MatHeaderCellDef,
    MatCellDef,
    MatRowDef,
    MatHeaderRowDef,
    MatInput,
    MatSort,
    MatHeaderRow,
    MatRow,
    MomentPipe,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
  ],
})
export class RegistrationDebuggerComponent implements OnInit {
  response$: Observable<RegistrationProcessInfoResponse>;
  entries$: Observable<RegistrationProcessInfoResource[]>;

  @ViewChild(MatPaginator, {static: true})
  paginator: MatPaginator;

  @ViewChild(MatSort, {static: true})
  sort: MatSort;

  form = new UntypedFormGroup({
    text: new UntypedFormControl(''),
  });

  constructor(private readonly service: RegistrationProcessService) {}

  ngOnInit() {
    const pagination$ = this.paginator.page.pipe(
      map((x) => new Pagination(x.pageIndex * x.pageSize, x.pageSize)),
      startWith(new Pagination(0, 25)),
    );

    const formValues$ = this.form.valueChanges.pipe(startWith({}));

    const sortChange$ = this.sort.sortChange.pipe(startWith({active: 'created', direction: 'desc'}));

    const query$ = combineLatest([pagination$, formValues$, sortChange$]).pipe(
      map((x) => {
        const sort: Sort = x[2] as Sort;
        const offset = x[0].offset;
        const limit = x[0].limit;
        const query = x[1].text || undefined;
        const order = sort.active;
        const direction = this.capitalize(sort.direction) as 'Asc' | 'Desc';
        return new RegistrationProcessQuery(String(offset), String(limit), query, order, direction);
      }),
    );

    this.response$ = query$.pipe(
      switchMap((query) => this.service.getProcesses(query)),
      share(),
    );

    this.entries$ = this.response$.pipe(map((x) => x.results));
  }

  get displayedColumns(): string[] {
    return ['created', 'name', 'email', 'startupName', 'address', 'status'];
  }

  statusToColor(s: string): string {
    if (s === 'Done') {
      return '#7896BE';
    }
    if (s === 'Conflict') {
      return '#FF7800';
    }
    if (s === 'Onboarded') {
      return 'mauve';
    }
    return 'black';
  }

  statusToIcon(s: string): string {
    if (s === 'Done') {
      return 'fa-check-circle';
    }
    if (s === 'Conflict') {
      return 'fa-times-circle';
    }
    if (s === 'Onboarded') {
      return 'fa-pause-circle';
    }
    return 'black';
  }

  private capitalize(s: string): string | undefined {
    if (!s || s.length === 0) {
      return undefined;
    }
    return s[0].toUpperCase() + s.slice(1);
  }
}
